var render, staticRenderFns
import script from "./CBtn.vue?vue&type=script&lang=ts"
export * from "./CBtn.vue?vue&type=script&lang=ts"
import style0 from "./CBtn.vue?vue&type=style&index=0&id=d59607f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports